export const EMAIL_CONSTANTS = {
    TO_NAME: "Elevate Africa Academy",
  };